import reduceReducers from 'reduce-reducers'
import { intersectionWith, isEqual, reduce } from 'lodash-es'
import { ReducersMapObject } from 'redux'

export const reduceMultiProductReducers = <T>(productReducers, remoteReducers):ReducersMapObject<T, any> => {

    const sourceKeys = Object.keys(productReducers);
    const remoteKeys = Object.keys(remoteReducers);

    const allKeys = [...new Set([...sourceKeys,...remoteKeys])];
    const reducersThatNeedsToBeCombined = intersectionWith(sourceKeys,remoteKeys, isEqual);
    return reduce(allKeys,(acc,reducerKey)=>{
         if(reducersThatNeedsToBeCombined?.includes(reducerKey)){
            return {
                ...acc,
                [reducerKey]: reduceReducers(productReducers[reducerKey],remoteReducers[reducerKey])
             }
         }
         return {
             ...acc,
             [reducerKey]: productReducers?.[reducerKey] || remoteReducers?.[reducerKey],
         }
    },{} as ReducersMapObject<T, any>)
    
}